import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';

// Config de ambiente resuelta en runtime por el backend (GET api/appconfig), no un
// assets/config.json estatico -- asi el mismo build sirve Development/QA/Prod sin
// recompilar. Backend serializa camelCase por default (System.Text.Json) -- los getters
// de acá SIEMPRE leen camelCase, nunca PascalCase (ver gotcha ya conocido de la familia:
// leer PascalCase deja el campo undefined y rompe el login en silencio).
@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private appConfig: any;
    private baseUrl: string;
    private http: HttpClient;
    constructor(private handler: HttpBackend) {
        this.http = new HttpClient(handler);
        this.baseUrl = document.getElementsByTagName('base')[0].href;
    }

    loadAppConfig() {
        return this.http.get(this.baseUrl + 'api/appconfig')
            .toPromise()
            .then(data => {
                this.appConfig = data;
            });
    }

    get BaseUrl() {
        return this.baseUrl;
    }

    // Siempre "/" en este repo (nunca vino de config.json en la práctica, config.json
    // traía "BaseUrl": "/" fijo) -- se mantiene como constante para no romper los 2
    // componentes de navbar que lo consumen (logo -> home).
    get HomeUrl() {
        return '/';
    }

    get OicUrl() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.oicUrl;
    }

    get OicAudience() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.oicAudience;
    }

    get IdentityAdminUrl() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.identityAdminUrl;
    }

    get ClientId() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.clientId;
    }

    get Scope() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.scope;
    }

}

